import { Component, Input, OnInit, signal, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { QPointIconModule } from '@qpoint/icons';

@Component({
    selector: 'qpoint-contextbar-section',
    templateUrl: './contextbar-section.component.html',
    styleUrls: ['./contextbar-section.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [CommonModule, NgbAccordionModule, QPointIconModule]
})
export class QPointContextbarSectionComponent implements OnInit {
  @Input() open: boolean = false;
  @Input() title: string = 'Section';
  collapsed = signal<boolean>(true);

  ngOnInit() {
    if( this.open ) {
      this.collapsed.set(false);
    }
  }

  onExpand() {
    this.collapsed.set(false);
  }

  onCollapse() {
    this.collapsed.set(true);   
  }

  public get isPanelOpen(): boolean {
    return this.collapsed() === false;
  }
}
